// extracted by mini-css-extract-plugin
export var border = "_p-8";
export var brand = "_p-t";
export var button = "_p-l";
export var center = "_p-a";
export var centered = "_p-6";
export var closeButton = "_p-c";
export var disabledWrapper = "_p-m";
export var error = "_p-p";
export var extraLarge = "_p-4";
export var extraSmall = "_p-1";
export var fill = "_p-i";
export var footer = "_p-h";
export var footerAction = "_p-j";
export var footerButtons = "_p-k";
export var header = "_p-7";
export var headerWithClose = "_p-d";
export var icon = "_p-o";
export var info = "_p-s";
export var inline = "_p-9";
export var large = "_p-3";
export var main = "_p-e";
export var modal = "_p-0";
export var nearFull = "_p-5";
export var neutral = "_p-u";
export var noPadding = "_p-g";
export var none = "_p-v";
export var scrollable = "_p-f";
export var small = "_p-2";
export var success = "_p-r";
export var tight = "_p-n";
export var titleIcon = "_p-b";
export var warn = "_p-q";